import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'
import { Button } from '@/shared/components/ui/button'
import { ServiceCatalog } from '../ServiceCatalog'
import { useAddPackageToBusiness } from '../../hooks/useAddPackageToBusiness'

interface AddServiceDialogProps {
  businessId: string
  open: boolean
  onOpenChange: (open: boolean) => void
  /** packageServiceId ya contratados → se muestran deshabilitados. */
  contractedServiceIds: number[]
  /** Se llama tras agregar con éxito (el padre refresca + avisa). */
  onAdded: () => void
}

export function AddServiceDialog({
  businessId,
  open,
  onOpenChange,
  contractedServiceIds,
  onAdded,
}: AddServiceDialogProps) {
  const [selected, setSelected] = useState<number[]>([])
  const { addPackage, loading } = useAddPackageToBusiness(businessId)

  // Limpia la selección al cerrar (evita setState en efecto al reabrir).
  const handleOpenChange = (next: boolean) => {
    if (!next) setSelected([])
    onOpenChange(next)
  }

  const toggle = (id: number) =>
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    )

  const handleConfirm = async () => {
    // Alta en paralelo de todos los servicios seleccionados.
    const results = await Promise.all(selected.map((id) => addPackage(id)))
    if (results.some((r) => r === null)) return // hubo error(es); el hook ya avisó
    onAdded()
    handleOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Agregar servicio</DialogTitle>
          <DialogDescription>
            Selecciona los servicios a contratar. El cambio se aplicará en el próximo ciclo
            de facturación.
          </DialogDescription>
        </DialogHeader>

        <div className="max-h-[60vh] overflow-y-auto pr-1">
          <ServiceCatalog
            mode="select"
            selectedIds={selected}
            disabledIds={contractedServiceIds}
            onToggle={toggle}
          />
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="ghost"
            onClick={() => handleOpenChange(false)}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={handleConfirm}
            disabled={loading || selected.length === 0}
          >
            {loading ? 'Agregando…' : `Agregar (${selected.length})`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
